<template>
  <div id="app">
    <bp-header v-if="this.showMenu" />
    <div class="menu-container">
      <sidebar-menu :collapsed="collapsed" width='420px'  :menu="menu" v-if="this.showMenu" />
    </div>
    <router-view :key="$route.fullPath" :tables="visibleTables"/>
  </div>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
import BPHeader from "./components/shared/BPHeader";
import VueCookies from 'vue-cookies';
import getSideMenu from './mixins/sideMenu.js'
import ULNavHeader from "./components/shared/ULNavHeader";
global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

export default {
  name: "app",
  components: {
    SidebarMenu,
    "bp-header": BPHeader,
    "ul-nav": ULNavHeader
  },
  mixins: [getSideMenu],
  async beforeUpdate() {
    if (this.$route.path === "/login") {
      this.showMenu = false;
      this.tables = [];
      localStorage.removeItem('roles');
      localStorage.removeItem('tables');
    } else {
      this.showMenu = true;

      // check tables length; otherwise can enter infinite loop of fetching tables
      if (!this.tables || this.tables.length === 0) {
        let roles = JSON.parse(localStorage.getItem('roles'));
        this.tables = await this.loadTables(roles);
         
        this.visibleTables = this.getVisibleTables(roles);
        localStorage.setItem('tables', JSON.stringify(this.tables));
        this.menu = this.getSideMenu(this.visibleTables, roles);
      }
    }
  },
  mounted() {
    
    if (this.$route.path === "/login") {
      this.showMenu = false;
    } else {
      this.showMenu = true;
    }

    if (window.location.href.indexOf("bfed_batch_id") > -1) {
       this.batch_id  = JSON.parse(
          JSON.stringify(decodeURIComponent(window.location.href ? window.location.href.split("?")[1] : window.location.search.slice(1)))
        );
          this.batch_id = this.batch_id.replace('bfed_batch_id=', '');
    } 
  },
  data() {
    return {
      message: "",
      data: null,
      tables: [],
      visibleTables: [],
      showMenu: false,
      menu: [],
      collapsed: true,
      themes: ["", "white-theme"],
      selectedTheme: "white-theme",
      batch_id: null,
    };
  },
  methods: {
    async loadTables(roles) {
      // determine which tables the user should see on the home and side menus
      const headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/table_permissions`;
      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      });
      response = await response.json();

      if (response.status == 403 || !response.success) {
        alert(response.message);
        window.location.href = '/login';
      } else {
        if (response.data) {
          // for staff, even if the only permission is select; for non-staff, only show tables with INSERT/UPDATE/DELETE permissions
          // this is because non-staff need certain permissions only for constraint checks, but they shouldn't see those tables in the menu
          if (roles.includes('reader') || roles.includes('writer') || roles.includes('admin')) {
            return response.data;
          } else {
            return response.data.filter(table => {
              return (table.permissions.length > 1 || !table.permissions.includes('SELECT'))
            });
          }
          
        } 
      }
    },
    // filter out tables that roles don't need to see in the menus
    getVisibleTables(roles) {
      if (roles.includes('admin') || roles.includes('maps')) {
        return this.tables.filter(table => {
          return !['census', 'convention_delegates', 'district_boundaries', 'electoral_college_votes', 'users','ultralocal.ul_offices_creation_workflow','ultralocal.ul_office_matching', 'ultralocal.ul_operation_logs'].includes(table.name);
        });
      } else if (roles.includes('writer') || roles.includes('reader')) {
        return this.tables.filter(table => {
          return !['census', 'convention_delegates', 'district_boundaries', 'districts', 'electoral_college_votes', 'users','ultralocal.ul_offices_creation_workflow','ultralocal.ul_office_matching'].includes(table.name);
        });
      } else if (roles.includes('school_research_contractor')) {
        return this.tables.filter(table => {
          return table.name.includes('research');
        });
      } else if (roles.includes('local_candidate_endorsements_volunteer')) {
        return this.tables.filter(table => {
          return !['contact_information'].includes(table.name);
        });
      } else {
        return this.tables;
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

.menu-container {
  text-align: center !important;
 }

/* Fix crowding */

.vue-query-builder-styled label,
.btn,
select {
  margin-right: 5px;
}

.vsm-link {
  text-align: left;
}
body .handsontable .success {
  background: #dcedc8;
}

body .handsontable .validation-error {
  background: #ff4c4288 !important;
}

.handsontable .htDimmed {
  background: #EEEEEE;
}

.handsontable.listbox tr td {
  background: #f8f8f8 !important;
}

.handsontable.listbox tr td.current, .handsontable.listbox tr:hover td {
    background: yellow !important;
}

.handsontable.listbox .ht_master table {
  border: 2px solid #ccc !important;
}
.currentRow {
  background-color: #E7E8EF !important;
}
.currentCol {
  background-color: #E7E8EF !important;
}
/* Must NOT be scoped */
.ql-container .ql-editor ol,
.ql-container .ql-editor ul {
  list-style: revert !important;
  padding-left: 1.5em !important;
}

.ql-container .ql-editor li {
  list-style: revert !important;
  display: list-item !important;
  padding-left: 0 !important;
}
</style>
